/* eslint-disable ember/no-mixins */
import Controller from '@ember/controller';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import { service } from '@ember/service';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import { action } from '@ember/object';

export default class NoticeController extends Controller.extend(EditPostMixin) {
  @service
  router;

  PostTypes = PostTypes;

  @action
  goToNotice(post) {
    this.router.transitionTo(post.get('url'));
  }
}
